import kynwardLogo from '../../../../assets/images/kynward-mark.png';
import './KynwardLogo.css';

export type KynwardLogoProps = {
  size?: number;
  className?: string;
  glow?: 'none' | 'subtle' | 'hero';
  alt?: string;
};

/**
 * The Kynward mark for marketing hero, nav, and premium moments.
 *
 * Same drawing as the app icon and the in-app mark — regenerate all of them together with
 * `npm run icons:generate` from the repo root.
 */
export function KynwardLogo({
  size = 72,
  className = '',
  glow = 'none',
  alt = 'Kynward',
}: KynwardLogoProps) {
  const glowClass =
    glow === 'hero' ? 'kyn-logo--glowHero' : glow === 'subtle' ? 'kyn-logo--glowSubtle' : '';

  return (
    <span
      className={`kyn-logo ${glowClass} ${className}`.trim()}
      style={{ width: size, height: size }}
      role="img"
      aria-label={alt}>
      <img
        className="kyn-logo__img"
        src={kynwardLogo}
        width={size}
        height={size}
        alt=""
        decoding="async"
        draggable={false}
      />
    </span>
  );
}
